// required babel/preset-env loose: true be disabled to avoid
// Class constructor Controller cannot be invoked without 'new'
import { Controller } from "@hotwired/stimulus";
import  PeriodicalExecuter from "lib/periodical_executer" 

export default class extends Controller {

  // update_timestamps() {
  //   $(".feed_item_timestamp").show();
  //   $(".time_ago").hide();
  // }


  connect() {
    if(this.partialPlayCountValue == 0){ return }

    this.load("full");
    this.startRefresh();
  }

  load(amount){

    $("input[name=full]").val(amount == "full");
    this.element.requestSubmit();
  }

  submitParentForm(event) {
    $("input[name=full]").val(true);
    var element = event.target;
    $(element).closest("form")[0].requestSubmit();
  }

  startRefresh(){
    this.refresh_count = 0;

    this.pe = new PeriodicalExecuter(() => {
      if (this.refresh_count < 60) {
        this.refresh_count++;
        $("input[name=full]").val(false);
        this.load("incremental");

      }
    }, 60);
  }

  disconnect() {
    this.pe?.stop();

  }
}
